const AgeVerification = ({ formData, handleChange, nextStep, prevStep, errors }) => {
  const calculateAge = (dob) => {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const age = calculateAge(formData.dob);

  return (
    <div className="form-container">
      <h2>Age Verification</h2>
      <form>
        <div className={errors.dob ? 'error' : ''}>
          <label>Date of Birth:</label>
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            required
            max={new Date().toISOString().split('T')[0]}
          />
          {errors.dob && <div className="error-message">{errors.dob}</div>}
        </div>

        {formData.dob && (
          <div className="age-result">
            {age < 21 ? (
              <p className="error">You must be at least 21 years old.</p>
            ) : age > 55 ? (
              <p className="error">Sorry, applicants over 55 are not eligible.</p>
            ) : (
              <p>Your age: {age} years (Eligible)</p>
            )}
          </div>
        )}

        <div className="button-group">
          <button type="button" onClick={prevStep}>Back</button>
          <button 
            type="button" 
            onClick={nextStep}
            disabled={!formData.dob || age < 21 || age > 55}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default AgeVerification;